import React from 'react';
import { COLOR } from './tokens';

// Consistent page title bar: h1 + optional subtitle, with optional
// right-side action slot (buttons, filters, exports).

const styles = {
  header: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 20,
    flexWrap: 'wrap',
  },
  h1: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: COLOR.ink,
    margin: 0,
    letterSpacing: '-0.01em',
  },
  sub: {
    color: COLOR.muted,
    fontSize: '0.9rem',
    margin: '4px 0 0',
  },
  actions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
};

export default function PageHeader({ title, subtitle, actions, style }) {
  return (
    <header style={{ ...styles.header, ...style }}>
      <div>
        <h1 style={styles.h1}>{title}</h1>
        {subtitle && <p style={styles.sub}>{subtitle}</p>}
      </div>
      {actions && <div style={styles.actions}>{actions}</div>}
    </header>
  );
}
